import {useEffect} from 'react'
import {Box, Label, type LabelProps, merge} from '@primer/react'
import type {BetterSystemStyleObject} from '@primer/react/lib-esm/sx'
import {testIdProps} from '@github-ui/test-id-props'
import {useListItemTrailingBadge} from './TrailingBadgeContext'

export type TrailingBadgeProps = Pick<LabelProps, 'variant' | 'size'> & {
  /**
   * Text that is shown as a visible Primer Label and as visually hidden text for screen readers.
   */
  title: string

  /**
   * Styling for the div surrounding the label
   */
  containerSx?: BetterSystemStyleObject
}

const defaultContainerSx: BetterSystemStyleObject = {display: 'inline-block', ml: 2}

export const TrailingBadge = ({title, containerSx, ...props}: TrailingBadgeProps) => {
  const {setTrailingBadge} = useListItemTrailingBadge()
  useEffect(() => setTrailingBadge(title), [setTrailingBadge, title])

  return (
    <Box
      {...testIdProps('listview-item-trailing-badge')}
      sx={containerSx ? merge<BetterSystemStyleObject>(defaultContainerSx, containerSx) : defaultContainerSx}
    >
      <span className="sr-only">: </span>
      <Label sx={{overflow: 'hidden', display: 'grid'}} {...props}>
        <Box as="span" sx={{textOverflow: 'ellipsis', overflow: 'hidden', lineHeight: 'normal'}}>
          {title}
        </Box>
      </Label>
    </Box>
  )
}

try{ TrailingBadge.displayName ||= 'TrailingBadge' } catch {}